/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderBase,
  OrderBaseOptional,
  OrderBaseMetaI,
  OrderBaseTrackedI,
} from "./order-base";
import { OrderBaseTracked, OrderBaseMeta } from "./order-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderCalculated,
  OrderCalculatedOptional,
  OrderCalculatedMetaI,
  OrderCalculatedTrackedI,
} from "./order-calculated";
import {
  OrderCalculatedTracked,
  OrderCalculatedMeta,
} from "./order-calculated";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderSource,
  OrderSourceOptional,
  OrderSourceMetaI,
  OrderSourceTrackedI,
} from "./order-source";
import { OrderSourceTracked, OrderSourceMeta } from "./order-source";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderStateNew,
  OrderStateNewOptional,
  OrderStateNewMetaI,
  OrderStateNewTrackedI,
} from "./order-state-new";
import { OrderStateNewTracked, OrderStateNewMeta } from "./order-state-new";

/**
 *
 * @export
 * @interface OrderSummaryDTO
 */
export interface OrderSummaryDTOOptional extends OrderBaseOptional {
  /**
   *
   * @type {OrderSource}
   * @memberof OrderSummaryDTO
   */
  orderSource?: OrderSource;
  /**
   * Total of all items before discounts and taxes
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountSubtotalCents?: number;
  /**
   * Total of all discounts applied
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountDiscountsCents?: number;
  /**
   * Total of all taxes applied
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountTaxesCents?: number;
  /**
   * Total of all items with discounts and taxes
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountTotalCents?: number;
  /**
   * Total of all successful payments
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountPaidCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  version?: number;
  /**
   *
   * @type {OrderStateNew}
   * @memberof OrderSummaryDTO
   */
  orderStatus?: OrderStateNew;
  /**
   *
   * @type {string}
   * @memberof OrderSummaryDTO
   */
  squareOrderId?: string;
  /**
   * Total cost of service charges (Payment fees paid by customer, maybe we will add restock service fee?)
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountServiceChangeCents?: number;
  /**
   * Total of all capturable payments
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountCapturableCents?: number;
  /**
   * Total of all capturable and paid payments
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountAppliedCents?: number;
  /**
   * Total of all pending payments
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountPendingCents?: number;
  /**
   * Total of all refunded payments
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountRefundedCents?: number;
  /**
   * Total of all refunded items
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountToRefundCents?: number;
  /**
   * Total of all non-refunded items
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountToPayCents?: number;
}

export interface OrderSummaryDTO
  extends OrderSummaryDTOOptional, OrderBase, OrderCalculated {
  /**
   *
   * @type {OrderSource}
   * @memberof OrderSummaryDTO
   */
  orderSource?: OrderSource;
  /**
   * Total of all items before discounts and taxes
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountSubtotalCents?: number;
  /**
   * Total of all discounts applied
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountDiscountsCents?: number;
  /**
   * Total of all taxes applied
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountTaxesCents?: number;
  /**
   * Total of all items with discounts and taxes
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountTotalCents?: number;
  /**
   * Total of all successful payments
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountPaidCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  version: number;
  /**
   *
   * @type {OrderStateNew}
   * @memberof OrderSummaryDTO
   */
  orderStatus?: OrderStateNew;
  /**
   *
   * @type {string}
   * @memberof OrderSummaryDTO
   */
  squareOrderId?: string;
  /**
   * Total cost of service charges (Payment fees paid by customer, maybe we will add restock service fee?)
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountServiceChangeCents?: number;
  /**
   * Total of all capturable payments
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountCapturableCents?: number;
  /**
   * Total of all capturable and paid payments
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountAppliedCents?: number;
  /**
   * Total of all pending payments
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountPendingCents?: number;
  /**
   * Total of all refunded payments
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountRefundedCents?: number;
  /**
   * Total of all refunded items
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountToRefundCents?: number;
  /**
   * Total of all non-refunded items
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountToPayCents?: number;
}

export interface OrderSummaryDTOTrackedI extends OrderBaseOptional {
  /**
   *
   * @type {OrderSource}
   * @memberof OrderSummaryDTO
   */
  orderSource?: OrderSource;
  orderSourceIsSet: boolean;
  /**
   * Total of all items before discounts and taxes
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountSubtotalCents?: number;
  amountSubtotalCentsIsSet: boolean;
  /**
   * Total of all discounts applied
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountDiscountsCents?: number;
  amountDiscountsCentsIsSet: boolean;
  /**
   * Total of all taxes applied
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountTaxesCents?: number;
  amountTaxesCentsIsSet: boolean;
  /**
   * Total of all items with discounts and taxes
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountTotalCents?: number;
  amountTotalCentsIsSet: boolean;
  /**
   * Total of all successful payments
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountPaidCents?: number;
  amountPaidCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  version?: number;
  versionIsSet: boolean;
  /**
   *
   * @type {OrderStateNew}
   * @memberof OrderSummaryDTO
   */
  orderStatus?: OrderStateNew;
  orderStatusIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderSummaryDTO
   */
  squareOrderId?: string;
  squareOrderIdIsSet: boolean;
  /**
   * Total cost of service charges (Payment fees paid by customer, maybe we will add restock service fee?)
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountServiceChangeCents?: number;
  amountServiceChangeCentsIsSet: boolean;
  /**
   * Total of all capturable payments
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountCapturableCents?: number;
  amountCapturableCentsIsSet: boolean;
  /**
   * Total of all capturable and paid payments
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountAppliedCents?: number;
  amountAppliedCentsIsSet: boolean;
  /**
   * Total of all pending payments
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountPendingCents?: number;
  amountPendingCentsIsSet: boolean;
  /**
   * Total of all refunded payments
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountRefundedCents?: number;
  amountRefundedCentsIsSet: boolean;
  /**
   * Total of all refunded items
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountToRefundCents?: number;
  amountToRefundCentsIsSet: boolean;
  /**
   * Total of all non-refunded items
   * @type {number}
   * @memberof OrderSummaryDTO
   */
  amountToPayCents?: number;
  amountToPayCentsIsSet: boolean;
}

transformDatesMap.set("OrderSummaryDTO", function (model: OrderSummaryDTO) {});

export type OrderSummaryDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  orderSource: PropertyMeta<OrderSourceMetaI>;
  //isDate: false
  //isDatetime: false
  amountSubtotalCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountDiscountsCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountTaxesCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountTotalCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountPaidCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  version: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  orderStatus: PropertyMeta<OrderStateNewMetaI>;
  //isDate: false
  //isDatetime: false
  squareOrderId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  amountServiceChangeCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountCapturableCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountAppliedCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountPendingCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountRefundedCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountToRefundCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountToPayCents: PropertyMeta<MetaTypeBase<number>>;
}>;

export var OrderSummaryDTOMeta: OrderSummaryDTOMetaI =
  {} as OrderSummaryDTOMetaI;
OrderSummaryDTOMeta = typeMeta("OrderSummaryDTO", {
  orderSource: propertyMeta(
    "orderSource",
    false,
    false,
    false,
    OrderSourceMeta,
  ),
  amountSubtotalCents: propertyMeta(
    "amountSubtotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountDiscountsCents: propertyMeta(
    "amountDiscountsCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountTaxesCents: propertyMeta(
    "amountTaxesCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountTotalCents: propertyMeta(
    "amountTotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountPaidCents: propertyMeta(
    "amountPaidCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  version: propertyMeta("version", false, true, false, MetaTypesBase.number),
  orderStatus: propertyMeta(
    "orderStatus",
    false,
    false,
    false,
    OrderStateNewMeta,
  ),
  squareOrderId: propertyMeta(
    "squareOrderId",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  amountServiceChangeCents: propertyMeta(
    "amountServiceChangeCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountCapturableCents: propertyMeta(
    "amountCapturableCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountAppliedCents: propertyMeta(
    "amountAppliedCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountPendingCents: propertyMeta(
    "amountPendingCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountRefundedCents: propertyMeta(
    "amountRefundedCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountToRefundCents: propertyMeta(
    "amountToRefundCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountToPayCents: propertyMeta(
    "amountToPayCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = OrderSummaryDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([OrderBaseMeta]);
  metaI.orderSource.inheritedFrom = OrderBaseMeta.orderSource;
  metaI.amountSubtotalCents.inheritedFrom = OrderBaseMeta.amountSubtotalCents;
  metaI.amountDiscountsCents.inheritedFrom = OrderBaseMeta.amountDiscountsCents;
  metaI.amountTaxesCents.inheritedFrom = OrderBaseMeta.amountTaxesCents;
  metaI.amountTotalCents.inheritedFrom = OrderBaseMeta.amountTotalCents;
  metaI.amountPaidCents.inheritedFrom = OrderBaseMeta.amountPaidCents;
  metaI.version.inheritedFrom = OrderBaseMeta.version;
  metaI.orderStatus.inheritedFrom = OrderBaseMeta.orderStatus;
  metaI.squareOrderId.inheritedFrom = OrderBaseMeta.squareOrderId;
  metaI.interfaces = metaI.interfaces.concat([OrderCalculatedMeta]);
  metaI.amountServiceChangeCents.inheritedFrom =
    OrderCalculatedMeta.amountServiceChangeCents;
  metaI.amountCapturableCents.inheritedFrom =
    OrderCalculatedMeta.amountCapturableCents;
  metaI.amountAppliedCents.inheritedFrom =
    OrderCalculatedMeta.amountAppliedCents;
  metaI.amountPendingCents.inheritedFrom =
    OrderCalculatedMeta.amountPendingCents;
  metaI.amountRefundedCents.inheritedFrom =
    OrderCalculatedMeta.amountRefundedCents;
  metaI.amountToRefundCents.inheritedFrom =
    OrderCalculatedMeta.amountToRefundCents;
  metaI.amountToPayCents.inheritedFrom = OrderCalculatedMeta.amountToPayCents;
});

export class OrderSummaryDTOTracked
  extends OrderBaseTracked
  implements OrderSummaryDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  orderSource__I?: OrderSource = undefined;
  orderSourceIsSet: boolean = false;
  set orderSource(v: undefined | OrderSource) {
    if (v !== undefined) {
      this.orderSource__I = v;
      this.orderSourceIsSet = true;
    } else {
      this.orderSource__I = v || undefined;
      this.orderSourceIsSet = false;
    }
    this.changeTracker = true;
  }
  get orderSource() {
    return this.orderSource__I;
  }
  amountSubtotalCents__I?: number = undefined;
  amountSubtotalCentsIsSet: boolean = false;
  set amountSubtotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountSubtotalCents__I = v;
      this.amountSubtotalCentsIsSet = true;
    } else {
      this.amountSubtotalCents__I = v || undefined;
      this.amountSubtotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountSubtotalCents() {
    return this.amountSubtotalCents__I;
  }
  amountDiscountsCents__I?: number = undefined;
  amountDiscountsCentsIsSet: boolean = false;
  set amountDiscountsCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountDiscountsCents__I = v;
      this.amountDiscountsCentsIsSet = true;
    } else {
      this.amountDiscountsCents__I = v || undefined;
      this.amountDiscountsCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountDiscountsCents() {
    return this.amountDiscountsCents__I;
  }
  amountTaxesCents__I?: number = undefined;
  amountTaxesCentsIsSet: boolean = false;
  set amountTaxesCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountTaxesCents__I = v;
      this.amountTaxesCentsIsSet = true;
    } else {
      this.amountTaxesCents__I = v || undefined;
      this.amountTaxesCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountTaxesCents() {
    return this.amountTaxesCents__I;
  }
  amountTotalCents__I?: number = undefined;
  amountTotalCentsIsSet: boolean = false;
  set amountTotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountTotalCents__I = v;
      this.amountTotalCentsIsSet = true;
    } else {
      this.amountTotalCents__I = v || undefined;
      this.amountTotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountTotalCents() {
    return this.amountTotalCents__I;
  }
  amountPaidCents__I?: number = undefined;
  amountPaidCentsIsSet: boolean = false;
  set amountPaidCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountPaidCents__I = v;
      this.amountPaidCentsIsSet = true;
    } else {
      this.amountPaidCents__I = v || undefined;
      this.amountPaidCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountPaidCents() {
    return this.amountPaidCents__I;
  }
  version__I?: number = undefined;
  versionIsSet: boolean = false;
  set version(v: undefined | number) {
    if (v !== undefined) {
      this.version__I = v;
      this.versionIsSet = true;
    } else {
      this.version__I = v || undefined;
      this.versionIsSet = true;
    }
    this.changeTracker = true;
  }
  get version() {
    return this.version__I;
  }
  orderStatus__I?: OrderStateNew = undefined;
  orderStatusIsSet: boolean = false;
  set orderStatus(v: undefined | OrderStateNew) {
    if (v !== undefined) {
      this.orderStatus__I = v;
      this.orderStatusIsSet = true;
    } else {
      this.orderStatus__I = v || undefined;
      this.orderStatusIsSet = false;
    }
    this.changeTracker = true;
  }
  get orderStatus() {
    return this.orderStatus__I;
  }
  squareOrderId__I?: string = undefined;
  squareOrderIdIsSet: boolean = false;
  set squareOrderId(v: undefined | string) {
    if (v !== undefined) {
      this.squareOrderId__I = v;
      this.squareOrderIdIsSet = true;
    } else {
      this.squareOrderId__I = v || undefined;
      this.squareOrderIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get squareOrderId() {
    return this.squareOrderId__I;
  }
  amountServiceChangeCents__I?: number = undefined;
  amountServiceChangeCentsIsSet: boolean = false;
  set amountServiceChangeCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountServiceChangeCents__I = v;
      this.amountServiceChangeCentsIsSet = true;
    } else {
      this.amountServiceChangeCents__I = v || undefined;
      this.amountServiceChangeCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountServiceChangeCents() {
    return this.amountServiceChangeCents__I;
  }
  amountCapturableCents__I?: number = undefined;
  amountCapturableCentsIsSet: boolean = false;
  set amountCapturableCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountCapturableCents__I = v;
      this.amountCapturableCentsIsSet = true;
    } else {
      this.amountCapturableCents__I = v || undefined;
      this.amountCapturableCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountCapturableCents() {
    return this.amountCapturableCents__I;
  }
  amountAppliedCents__I?: number = undefined;
  amountAppliedCentsIsSet: boolean = false;
  set amountAppliedCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountAppliedCents__I = v;
      this.amountAppliedCentsIsSet = true;
    } else {
      this.amountAppliedCents__I = v || undefined;
      this.amountAppliedCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountAppliedCents() {
    return this.amountAppliedCents__I;
  }
  amountPendingCents__I?: number = undefined;
  amountPendingCentsIsSet: boolean = false;
  set amountPendingCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountPendingCents__I = v;
      this.amountPendingCentsIsSet = true;
    } else {
      this.amountPendingCents__I = v || undefined;
      this.amountPendingCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountPendingCents() {
    return this.amountPendingCents__I;
  }
  amountRefundedCents__I?: number = undefined;
  amountRefundedCentsIsSet: boolean = false;
  set amountRefundedCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountRefundedCents__I = v;
      this.amountRefundedCentsIsSet = true;
    } else {
      this.amountRefundedCents__I = v || undefined;
      this.amountRefundedCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountRefundedCents() {
    return this.amountRefundedCents__I;
  }
  amountToRefundCents__I?: number = undefined;
  amountToRefundCentsIsSet: boolean = false;
  set amountToRefundCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountToRefundCents__I = v;
      this.amountToRefundCentsIsSet = true;
    } else {
      this.amountToRefundCents__I = v || undefined;
      this.amountToRefundCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountToRefundCents() {
    return this.amountToRefundCents__I;
  }
  amountToPayCents__I?: number = undefined;
  amountToPayCentsIsSet: boolean = false;
  set amountToPayCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountToPayCents__I = v;
      this.amountToPayCentsIsSet = true;
    } else {
      this.amountToPayCents__I = v || undefined;
      this.amountToPayCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountToPayCents() {
    return this.amountToPayCents__I;
  }
  constructor(config?: OrderSummaryDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: OrderSummaryDTOOptional,
    options?: AssignOptions,
  ): OrderSummaryDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.orderSource &&
      this.orderSourceApplyFilter(optionsRequired.filter)
    ) {
      this.orderSource = config.orderSource;
      if (optionsRequired.unassign) this.orderSourceIsSet = false;
      else this.orderSourceIsSet = true;
    }
    if (
      config.amountSubtotalCents &&
      this.amountSubtotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountSubtotalCents = config.amountSubtotalCents;
      if (optionsRequired.unassign) this.amountSubtotalCentsIsSet = false;
      else this.amountSubtotalCentsIsSet = true;
    }
    if (
      config.amountDiscountsCents &&
      this.amountDiscountsCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountDiscountsCents = config.amountDiscountsCents;
      if (optionsRequired.unassign) this.amountDiscountsCentsIsSet = false;
      else this.amountDiscountsCentsIsSet = true;
    }
    if (
      config.amountTaxesCents &&
      this.amountTaxesCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountTaxesCents = config.amountTaxesCents;
      if (optionsRequired.unassign) this.amountTaxesCentsIsSet = false;
      else this.amountTaxesCentsIsSet = true;
    }
    if (
      config.amountTotalCents &&
      this.amountTotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountTotalCents = config.amountTotalCents;
      if (optionsRequired.unassign) this.amountTotalCentsIsSet = false;
      else this.amountTotalCentsIsSet = true;
    }
    if (
      config.amountPaidCents &&
      this.amountPaidCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountPaidCents = config.amountPaidCents;
      if (optionsRequired.unassign) this.amountPaidCentsIsSet = false;
      else this.amountPaidCentsIsSet = true;
    }
    if (config.version && this.versionApplyFilter(optionsRequired.filter)) {
      this.version = config.version;
      if (optionsRequired.unassign) this.versionIsSet = false;
      else this.versionIsSet = true;
    }
    if (
      config.orderStatus &&
      this.orderStatusApplyFilter(optionsRequired.filter)
    ) {
      this.orderStatus = config.orderStatus;
      if (optionsRequired.unassign) this.orderStatusIsSet = false;
      else this.orderStatusIsSet = true;
    }
    if (
      config.squareOrderId &&
      this.squareOrderIdApplyFilter(optionsRequired.filter)
    ) {
      this.squareOrderId = config.squareOrderId;
      if (optionsRequired.unassign) this.squareOrderIdIsSet = false;
      else this.squareOrderIdIsSet = true;
    }
    if (
      config.amountServiceChangeCents &&
      this.amountServiceChangeCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountServiceChangeCents = config.amountServiceChangeCents;
      if (optionsRequired.unassign) this.amountServiceChangeCentsIsSet = false;
      else this.amountServiceChangeCentsIsSet = true;
    }
    if (
      config.amountCapturableCents &&
      this.amountCapturableCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountCapturableCents = config.amountCapturableCents;
      if (optionsRequired.unassign) this.amountCapturableCentsIsSet = false;
      else this.amountCapturableCentsIsSet = true;
    }
    if (
      config.amountAppliedCents &&
      this.amountAppliedCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountAppliedCents = config.amountAppliedCents;
      if (optionsRequired.unassign) this.amountAppliedCentsIsSet = false;
      else this.amountAppliedCentsIsSet = true;
    }
    if (
      config.amountPendingCents &&
      this.amountPendingCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountPendingCents = config.amountPendingCents;
      if (optionsRequired.unassign) this.amountPendingCentsIsSet = false;
      else this.amountPendingCentsIsSet = true;
    }
    if (
      config.amountRefundedCents &&
      this.amountRefundedCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountRefundedCents = config.amountRefundedCents;
      if (optionsRequired.unassign) this.amountRefundedCentsIsSet = false;
      else this.amountRefundedCentsIsSet = true;
    }
    if (
      config.amountToRefundCents &&
      this.amountToRefundCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountToRefundCents = config.amountToRefundCents;
      if (optionsRequired.unassign) this.amountToRefundCentsIsSet = false;
      else this.amountToRefundCentsIsSet = true;
    }
    if (
      config.amountToPayCents &&
      this.amountToPayCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountToPayCents = config.amountToPayCents;
      if (optionsRequired.unassign) this.amountToPayCentsIsSet = false;
      else this.amountToPayCentsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): OrderSummaryDTOTrackedI {
    const cloned = {} as OrderSummaryDTOTrackedI;
    if (
      this.orderSourceIsSetDeep() &&
      this.orderSourceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.orderSourceIsSet = true;
      cloned.orderSource = this.orderSource;
    } else {
      //cloned.orderSourceIsSet = false
    }
    if (
      this.amountSubtotalCentsIsSetDeep() &&
      this.amountSubtotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountSubtotalCentsIsSet = true;
      cloned.amountSubtotalCents = this.amountSubtotalCents;
    } else {
      //cloned.amountSubtotalCentsIsSet = false
    }
    if (
      this.amountDiscountsCentsIsSetDeep() &&
      this.amountDiscountsCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountDiscountsCentsIsSet = true;
      cloned.amountDiscountsCents = this.amountDiscountsCents;
    } else {
      //cloned.amountDiscountsCentsIsSet = false
    }
    if (
      this.amountTaxesCentsIsSetDeep() &&
      this.amountTaxesCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountTaxesCentsIsSet = true;
      cloned.amountTaxesCents = this.amountTaxesCents;
    } else {
      //cloned.amountTaxesCentsIsSet = false
    }
    if (
      this.amountTotalCentsIsSetDeep() &&
      this.amountTotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountTotalCentsIsSet = true;
      cloned.amountTotalCents = this.amountTotalCents;
    } else {
      //cloned.amountTotalCentsIsSet = false
    }
    if (
      this.amountPaidCentsIsSetDeep() &&
      this.amountPaidCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountPaidCentsIsSet = true;
      cloned.amountPaidCents = this.amountPaidCents;
    } else {
      //cloned.amountPaidCentsIsSet = false
    }
    if (
      this.versionIsSetDeep() &&
      this.versionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.versionIsSet = true;
      cloned.version = this.version;
    } else {
      //cloned.versionIsSet = false
    }
    if (
      this.orderStatusIsSetDeep() &&
      this.orderStatusApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.orderStatusIsSet = true;
      cloned.orderStatus = this.orderStatus;
    } else {
      //cloned.orderStatusIsSet = false
    }
    if (
      this.squareOrderIdIsSetDeep() &&
      this.squareOrderIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.squareOrderIdIsSet = true;
      cloned.squareOrderId = this.squareOrderId;
    } else {
      //cloned.squareOrderIdIsSet = false
    }
    if (
      this.amountServiceChangeCentsIsSetDeep() &&
      this.amountServiceChangeCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountServiceChangeCentsIsSet = true;
      cloned.amountServiceChangeCents = this.amountServiceChangeCents;
    } else {
      //cloned.amountServiceChangeCentsIsSet = false
    }
    if (
      this.amountCapturableCentsIsSetDeep() &&
      this.amountCapturableCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountCapturableCentsIsSet = true;
      cloned.amountCapturableCents = this.amountCapturableCents;
    } else {
      //cloned.amountCapturableCentsIsSet = false
    }
    if (
      this.amountAppliedCentsIsSetDeep() &&
      this.amountAppliedCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountAppliedCentsIsSet = true;
      cloned.amountAppliedCents = this.amountAppliedCents;
    } else {
      //cloned.amountAppliedCentsIsSet = false
    }
    if (
      this.amountPendingCentsIsSetDeep() &&
      this.amountPendingCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountPendingCentsIsSet = true;
      cloned.amountPendingCents = this.amountPendingCents;
    } else {
      //cloned.amountPendingCentsIsSet = false
    }
    if (
      this.amountRefundedCentsIsSetDeep() &&
      this.amountRefundedCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountRefundedCentsIsSet = true;
      cloned.amountRefundedCents = this.amountRefundedCents;
    } else {
      //cloned.amountRefundedCentsIsSet = false
    }
    if (
      this.amountToRefundCentsIsSetDeep() &&
      this.amountToRefundCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountToRefundCentsIsSet = true;
      cloned.amountToRefundCents = this.amountToRefundCents;
    } else {
      //cloned.amountToRefundCentsIsSet = false
    }
    if (
      this.amountToPayCentsIsSetDeep() &&
      this.amountToPayCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountToPayCentsIsSet = true;
      cloned.amountToPayCents = this.amountToPayCents;
    } else {
      //cloned.amountToPayCentsIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): OrderSummaryDTOTrackedI {
    if (!this.orderSourceApplyFilter(filter)) this.orderSourceIsSet = false;

    if (!this.amountSubtotalCentsApplyFilter(filter))
      this.amountSubtotalCentsIsSet = false;

    if (!this.amountDiscountsCentsApplyFilter(filter))
      this.amountDiscountsCentsIsSet = false;

    if (!this.amountTaxesCentsApplyFilter(filter))
      this.amountTaxesCentsIsSet = false;

    if (!this.amountTotalCentsApplyFilter(filter))
      this.amountTotalCentsIsSet = false;

    if (!this.amountPaidCentsApplyFilter(filter))
      this.amountPaidCentsIsSet = false;

    if (!this.versionApplyFilter(filter)) this.versionIsSet = false;

    if (!this.orderStatusApplyFilter(filter)) this.orderStatusIsSet = false;

    if (!this.squareOrderIdApplyFilter(filter)) this.squareOrderIdIsSet = false;

    if (!this.amountServiceChangeCentsApplyFilter(filter))
      this.amountServiceChangeCentsIsSet = false;

    if (!this.amountCapturableCentsApplyFilter(filter))
      this.amountCapturableCentsIsSet = false;

    if (!this.amountAppliedCentsApplyFilter(filter))
      this.amountAppliedCentsIsSet = false;

    if (!this.amountPendingCentsApplyFilter(filter))
      this.amountPendingCentsIsSet = false;

    if (!this.amountRefundedCentsApplyFilter(filter))
      this.amountRefundedCentsIsSet = false;

    if (!this.amountToRefundCentsApplyFilter(filter))
      this.amountToRefundCentsIsSet = false;

    if (!this.amountToPayCentsApplyFilter(filter))
      this.amountToPayCentsIsSet = false;

    return this;
  }
  orderSourceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderSummaryDTOMeta.orderSource,
      OrderSummaryDTOMeta,
      this.orderSource,
      this,
    );
  }
  orderSourceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.orderSourceIsSet && this.orderSourceApplyFilter(filter))
      return true;

    return false;
  }
  amountSubtotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderSummaryDTOMeta.amountSubtotalCents,
      OrderSummaryDTOMeta,
      this.amountSubtotalCents,
      this,
    );
  }
  amountSubtotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountSubtotalCentsIsSet &&
      this.amountSubtotalCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountDiscountsCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderSummaryDTOMeta.amountDiscountsCents,
      OrderSummaryDTOMeta,
      this.amountDiscountsCents,
      this,
    );
  }
  amountDiscountsCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountDiscountsCentsIsSet &&
      this.amountDiscountsCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountTaxesCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderSummaryDTOMeta.amountTaxesCents,
      OrderSummaryDTOMeta,
      this.amountTaxesCents,
      this,
    );
  }
  amountTaxesCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountTaxesCentsIsSet && this.amountTaxesCentsApplyFilter(filter))
      return true;

    return false;
  }
  amountTotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderSummaryDTOMeta.amountTotalCents,
      OrderSummaryDTOMeta,
      this.amountTotalCents,
      this,
    );
  }
  amountTotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountTotalCentsIsSet && this.amountTotalCentsApplyFilter(filter))
      return true;

    return false;
  }
  amountPaidCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderSummaryDTOMeta.amountPaidCents,
      OrderSummaryDTOMeta,
      this.amountPaidCents,
      this,
    );
  }
  amountPaidCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountPaidCentsIsSet && this.amountPaidCentsApplyFilter(filter))
      return true;

    return false;
  }
  versionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderSummaryDTOMeta.version,
      OrderSummaryDTOMeta,
      this.version,
      this,
    );
  }
  versionIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.versionIsSet && this.versionApplyFilter(filter)) return true;

    return false;
  }
  orderStatusApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderSummaryDTOMeta.orderStatus,
      OrderSummaryDTOMeta,
      this.orderStatus,
      this,
    );
  }
  orderStatusIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.orderStatusIsSet && this.orderStatusApplyFilter(filter))
      return true;

    return false;
  }
  squareOrderIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderSummaryDTOMeta.squareOrderId,
      OrderSummaryDTOMeta,
      this.squareOrderId,
      this,
    );
  }
  squareOrderIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.squareOrderIdIsSet && this.squareOrderIdApplyFilter(filter))
      return true;

    return false;
  }
  amountServiceChangeCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderSummaryDTOMeta.amountServiceChangeCents,
      OrderSummaryDTOMeta,
      this.amountServiceChangeCents,
      this,
    );
  }
  amountServiceChangeCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountServiceChangeCentsIsSet &&
      this.amountServiceChangeCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountCapturableCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderSummaryDTOMeta.amountCapturableCents,
      OrderSummaryDTOMeta,
      this.amountCapturableCents,
      this,
    );
  }
  amountCapturableCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountCapturableCentsIsSet &&
      this.amountCapturableCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountAppliedCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderSummaryDTOMeta.amountAppliedCents,
      OrderSummaryDTOMeta,
      this.amountAppliedCents,
      this,
    );
  }
  amountAppliedCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountAppliedCentsIsSet &&
      this.amountAppliedCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountPendingCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderSummaryDTOMeta.amountPendingCents,
      OrderSummaryDTOMeta,
      this.amountPendingCents,
      this,
    );
  }
  amountPendingCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountPendingCentsIsSet &&
      this.amountPendingCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountRefundedCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderSummaryDTOMeta.amountRefundedCents,
      OrderSummaryDTOMeta,
      this.amountRefundedCents,
      this,
    );
  }
  amountRefundedCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountRefundedCentsIsSet &&
      this.amountRefundedCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountToRefundCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderSummaryDTOMeta.amountToRefundCents,
      OrderSummaryDTOMeta,
      this.amountToRefundCents,
      this,
    );
  }
  amountToRefundCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountToRefundCentsIsSet &&
      this.amountToRefundCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountToPayCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderSummaryDTOMeta.amountToPayCents,
      OrderSummaryDTOMeta,
      this.amountToPayCents,
      this,
    );
  }
  amountToPayCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountToPayCentsIsSet && this.amountToPayCentsApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.orderSourceIsSetDeep(filter)) return true;
    if (this.amountSubtotalCentsIsSetDeep(filter)) return true;
    if (this.amountDiscountsCentsIsSetDeep(filter)) return true;
    if (this.amountTaxesCentsIsSetDeep(filter)) return true;
    if (this.amountTotalCentsIsSetDeep(filter)) return true;
    if (this.amountPaidCentsIsSetDeep(filter)) return true;
    if (this.versionIsSetDeep(filter)) return true;
    if (this.orderStatusIsSetDeep(filter)) return true;
    if (this.squareOrderIdIsSetDeep(filter)) return true;
    if (this.amountServiceChangeCentsIsSetDeep(filter)) return true;
    if (this.amountCapturableCentsIsSetDeep(filter)) return true;
    if (this.amountAppliedCentsIsSetDeep(filter)) return true;
    if (this.amountPendingCentsIsSetDeep(filter)) return true;
    if (this.amountRefundedCentsIsSetDeep(filter)) return true;
    if (this.amountToRefundCentsIsSetDeep(filter)) return true;
    if (this.amountToPayCentsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
